// src/components/RecipeDetailModal.js

import React from 'react';
import '../styles/ClientRecipes.css'; // Use the same styles file

const RecipeDetailModal = ({ isOpen, onClose, recipe }) => {
    if (!isOpen || !recipe) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content recipe-detail-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>🍽️ {recipe.name}</h2>
                    <button className="close-button" onClick={onClose}>&times;</button>
                </div>

                <div className="recipe-details-body">
                    {/* Short Description */}
                    <p className="detail-description">{recipe.description}</p>
                    
                    {/* Ingredients Section */}
                    <div className="detail-section">
                        <h3>📋 Ingredients</h3>
                        <ul className="ingredients-list">
                            {/* Check if ingredients is an array before mapping */}
                            {Array.isArray(recipe.ingredients) && recipe.ingredients.map((item, index) => (
                                <li key={index}>
                                    <span className="bullet-point">•</span> {item}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Instructions Section */}
                    <div className="detail-section">
                        <h3>👩‍🍳 Instructions</h3>
                        {/* Display instructions nicely, converting new lines to paragraphs */}
                        <div className="instructions-text">
                            {recipe.instructions.split('\n').map((line, index) => (
                                line.trim() ? <p key={index}>{line}</p> : null
                            ))}
                        </div>
                    </div>

                    {/* Notes Section */}
                    {recipe.notes && (
                        <div className="detail-section notes-section">
                            <h3>📝 Notes</h3>
                            <p>{recipe.notes}</p>
                        </div>
                    )}
                    
                    <span className="uploaded-at-detail">
                        Uploaded: {recipe.uploadedAt && new Date(recipe.uploadedAt.toDate()).toLocaleDateString()}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default RecipeDetailModal;